module.exports = __webpack_public_path__ + "img/Mills_SuperOK-139.47ac4ae8.jpg";